<div class="payment-wrapper">
	<div class="payment-card">
		<h1 class="title">{{ 'Payment_Title' | translate }}</h1>
		<h3 class="subtitle">{{ 'Payment_SubTitle' | translate }}</h3>

		<form [formGroup]="form" (ngSubmit)="submit()" novalidate>
			<div class="field">
				<label for="email">{{ 'Email' | translate }}</label>
				<input id="email" type="email" formControlName="email" [class.invalid]="f['email'].invalid && (f['email'].dirty || f['email'].touched)" autocomplete="email">
				@if (f['email'].errors && (f['email'].dirty || f['email'].touched)) {
					<div class="error">
						@if (f['email'].errors['required']) { <span>{{ 'Payment_Error_Required' | translate }}</span> }
					</div>
				}
			</div>
			<div class="field">
				<label for="cardHolderName">{{ 'Payment_CardHolder' | translate }}</label>
				<input id="cardHolderName" type="text" formControlName="cardHolderName" [class.invalid]="f['cardHolderName'].invalid && (f['cardHolderName'].dirty || f['cardHolderName'].touched)" autocomplete="cc-name">
				@if (f['cardHolderName'].errors && (f['cardHolderName'].dirty || f['cardHolderName'].touched)) {
					<div class="error">
						@if (f['cardHolderName'].errors['required']) { <span>{{ 'Payment_Error_Required' | translate }}</span> }
					</div>
				}
			</div>

			<div class="field">
				<label for="cardNumber">{{ 'Payment_CardNumber' | translate }}</label>
				<input #cardNumberInput id="cardNumber" type="text" formControlName="cardNumber" inputmode="numeric" pattern="[0-9]*" maxlength="16" placeholder="0000000000000000" [class.invalid]="f['cardNumber'].invalid && (f['cardNumber'].dirty || f['cardNumber'].touched)" autocomplete="cc-number" (input)="onCardNumberInput($event)">
				@if (f['cardNumber'].errors && (f['cardNumber'].dirty || f['cardNumber'].touched)) {
					<div class="error">
						@if (f['cardNumber'].errors['required']) { <span>{{ 'Payment_Error_Required' | translate }}</span> }
						@if (f['cardNumber'].errors['invalidCardNumber']) { <span>{{ 'Payment_Error_InvalidCard' | translate }}</span> }
						@if (f['cardNumber'].errors['minlength'] || f['cardNumber'].errors['maxlength']) { <span>{{ 'Payment_Error_Length' | translate }}</span> }
					</div>
				}
			</div>

			<div class="row">
				<div class="field">
					<label for="expiryMonth">{{ 'Payment_ExpiryMonth' | translate }}</label>
					<input #expiryMonthInput id="expiryMonth" type="text" formControlName="expiryMonth" maxlength="2" inputmode="numeric" [class.invalid]="f['expiryMonth'].invalid && (f['expiryMonth'].dirty || f['expiryMonth'].touched)" autocomplete="cc-exp-month" (input)="onExpiryMonthInput($event)">
					@if (f['expiryMonth'].errors && (f['expiryMonth'].dirty || f['expiryMonth'].touched)) {
						<div class="error">
							@if (f['expiryMonth'].errors['required']) { <span>{{ 'Payment_Error_Required' | translate }}</span> }
							@if (f['expiryMonth'].errors['pattern']) { <span>{{ 'Payment_Error_InvalidMonth' | translate }}</span> }
						</div>
					}
				</div>
				<div class="field">
					<label for="expiryYear">{{ 'Payment_ExpiryYear' | translate }}</label>
					<input #expiryYearInput id="expiryYear" type="text" formControlName="expiryYear" maxlength="4" inputmode="numeric" [class.invalid]="f['expiryYear'].invalid && (f['expiryYear'].dirty || f['expiryYear'].touched)" autocomplete="cc-exp-year" (input)="onExpiryYearInput($event)">
					@if (f['expiryYear'].errors && (f['expiryYear'].dirty || f['expiryYear'].touched)) {
						<div class="error">
							@if (f['expiryYear'].errors['required']) { <span>{{ 'Payment_Error_Required' | translate }}</span> }
							@if (f['expiryYear'].errors['pattern']) { <span>{{ 'Payment_Error_InvalidYear' | translate }}</span> }
							@if (f['expiryYear'].errors['pastYear']) { <span>{{ 'Payment_Error_PastYear' | translate }}</span> }
							@if (f['expiryYear'].errors['farFutureYear']) { <span>{{ 'Payment_Error_FutureYear' | translate }}</span> }
						</div>
					}
				</div>
			</div>

			@if (form.errors?.['expiryPast'] && (f['expiryMonth'].touched || f['expiryYear'].touched)) {
				<div class="error">{{ 'Payment_Error_ExpiryPast' | translate }}</div>
			}

			<button #submitBtn type="submit" class="submit-btn" [disabled]="form.invalid || submitting()">
				@if (!submitting()) { <span>{{ 'Payment_Submit' | translate }}</span> }
				@if (submitting()) { <span>{{ 'Payment_Loading' | translate }}</span> }
			</button>
		</form>

		@if (successMessage()) { <div class="feedback success">{{ successMessage() | translate }}</div> }
		@if (errorMessage()) { <div class="feedback error">{{ errorMessage() | translate }}</div> }
	</div>
</div>
